import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AppCtx = createContext(null);

export const CURRENCIES = {
  INR: { code: "INR", symbol: "₹", label: "Indian Rupee (₹)", locale: "en-IN" },
  AED: { code: "AED", symbol: "AED ", label: "UAE Dirham (AED)", locale: "en-AE" },
};

export const formatMoney = (n, code) => {
  const c = CURRENCIES[code] || CURRENCIES.INR;
  const v = Number(n || 0);
  return `${v < 0 ? "-" : ""}${c.symbol}${Math.abs(v).toLocaleString(c.locale, { maximumFractionDigits: 2 })}`;
};

export function AppProvider({ children }) {
  const { getToken } = useAuth();
  const [me, setMe] = useState(null);
  const [error, setError] = useState(null);

  const api = useCallback(async (method, path, data) => {
    const token = await getToken();
    const res = await axios({ method, url: `${API}${path}`, data, headers: { Authorization: `Bearer ${token}` } });
    return res.data;
  }, [getToken]);

  const loadMe = useCallback(async () => {
    try {
      setMe(await api("get", "/me"));
    } catch (e) {
      setError(e?.response?.data?.detail || "Could not load your account");
    }
  }, [api]);

  useEffect(() => { loadMe(); }, [loadMe]);

  const value = useMemo(() => ({ api, me, error, reloadMe: loadMe }), [api, me, error, loadMe]);
  return <AppCtx.Provider value={value}>{children}</AppCtx.Provider>;
}

export const useApp = () => useContext(AppCtx);

export const useCanEdit = () => ["admin", "manager"].includes(useContext(AppCtx)?.me?.role);
